import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Never retry on 429 — it just floods the rate limit log with noise
      retry: (failureCount, error) => {
        if (error instanceof Error && error.message.includes('429')) return false;
        return failureCount < 2;
      },
    },
  },
});
